import { Link } from "react-router-dom";
import { home, solutions } from "@/content";
import { Rich } from "@/lib/rich";

export default function LightSolutions() {
  const { solutions: section } = home;

  return (
    <section id="solutions" className="py-24 bg-white dark:bg-[#0E0E0E] relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-stone-100 dark:bg-white/[0.06] text-stone-600 dark:text-white/70 text-xs font-semibold tracking-widest uppercase mb-4">
            {section.badge}
          </span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-stone-900 dark:text-white mb-4">
            <Rich text={section.title} accentClassName="text-orange-700 dark:text-orange-400" />
          </h2>
          {section.subtitle && (
            <p className="text-stone-600 dark:text-white/65 text-lg max-w-2xl mx-auto">
              {section.subtitle}
            </p>
          )}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {solutions.map((solution) => (
            <Link
              key={solution.slug}
              to={`/solutions#${solution.slug}`}
              className="group bg-[#FAFAF8] dark:bg-white/[0.04] border border-stone-100 dark:border-white/[0.08] rounded-2xl p-6 dark:backdrop-blur-xl hover:-translate-y-1 hover:border-stone-300 dark:hover:border-white/[0.16] hover:shadow-[0_8px_30px_rgba(0,0,0,0.04)] transition-all duration-300 cursor-pointer"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-stone-900 dark:bg-orange-500 mb-4">
                <i className={`${solution.icon} text-white dark:text-[#0A0A0A] text-lg`}></i>
              </div>
              <h3 className="text-base font-bold text-stone-900 dark:text-white mb-2">
                {solution.title}
              </h3>
              <p className="text-stone-600 dark:text-white/65 text-sm leading-relaxed mb-4">
                {solution.shortDesc}
              </p>
              <span className="inline-flex items-center gap-1.5 text-orange-600 dark:text-orange-400 text-sm font-semibold group-hover:gap-2.5 transition-all whitespace-nowrap">
                {section.cardLinkLabel}
                <i className="ri-arrow-right-line text-sm"></i>
              </span>
            </Link>
          ))}

          {/* Акцентная карточка аналитики */}
          <Link
            to={section.spotlight.href}
            className="group bg-gradient-to-br from-blue-50 dark:from-blue-500/[0.10] to-slate-50 dark:to-slate-500/[0.06] border-2 border-blue-200 dark:border-blue-500/25 rounded-2xl p-6 dark:backdrop-blur-xl hover:-translate-y-1 hover:border-blue-400 dark:hover:border-blue-400/50 hover:shadow-[0_8px_30px_rgba(59,130,246,0.12)] transition-all duration-300 cursor-pointer relative overflow-hidden"
          >
            <div className="absolute top-0 right-0 w-24 h-24 bg-blue-100/60 dark:bg-blue-500/10 rounded-bl-[80px] -mr-4 -mt-4" />
            <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-blue-600 dark:bg-blue-500 mb-4 relative">
              <i
                className={`${section.spotlight.icon} text-white text-lg`}
              ></i>
            </div>
            <div className="inline-block px-2.5 py-0.5 rounded-full bg-blue-100 dark:bg-blue-500/15 text-blue-700 dark:text-blue-300 text-[10px] font-bold uppercase tracking-wide mb-2">
              {section.spotlight.badge}
            </div>
            <h3 className="text-base font-bold text-slate-900 dark:text-white mb-2">
              {section.spotlight.title}
            </h3>
            <p className="text-slate-600 dark:text-white/65 text-sm leading-relaxed mb-4">
              {section.spotlight.text}
            </p>
            <span className="inline-flex items-center gap-1.5 text-blue-600 dark:text-blue-400 text-sm font-semibold group-hover:gap-2.5 transition-all whitespace-nowrap">
              {section.spotlight.linkLabel}
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}
